import React, {useState} from 'react'
import {Switch} from '@headlessui/react'
import Link from 'next/link'
import {ExclamationCircleIcon} from '@heroicons/react/solid'
import {useForm} from "react-hook-form";
import HCaptcha from "@hcaptcha/react-hcaptcha";
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/solid';

// @ts-ignore
function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

// const formContext = React.createContext("unsent");

let formData: any;

export default function ContactForm() {
    const [agreed, setAgreed] = useState(false)
    const [formState, setFormState] = useState({sent: false, error: false})
    const hcaptchaRef = React.useRef(null);



    const {register, handleSubmit, formState: {errors}} = useForm({
        mode: 'onBlur',
        reValidateMode: 'onChange'
    });
    // @ts-ignore
    const onSubmit = (data, e) => {
        console.log(e)
        e.preventDefault();
        e.stopPropagation();
        // Execute the reCAPTCHA when the form is submitted
        formData = data
        // @ts-ignore
        hcaptchaRef.current.execute();
    };

    // @ts-ignore
    const onHCaptchaChange = async (captchaCode) => {
        // If the hCaptcha code is null or undefined indicating that
        // the hCaptcha was expired then return early
        // console.log(formData)
        if (!captchaCode) {
            return;
        }
        try {
            // @ts-ignore
            const response = await fetch("/api/contactForm", {
                method: "POST",
                body: JSON.stringify({ formData, captcha: captchaCode }),
                headers: {
                    "Content-Type": "application/json",
                },
            });
            if (response.ok) {
                // If the response is ok than show the success alert
                // console.log("Email registered successfully");
                setFormState({sent: true, error: false});
            } else {
                // Else throw an error with the message returned
                // from the API
                await response.json();
                setFormState({sent: true, error: true});
                // throw new Error(error.message)
            }
        } catch (error) {
            setFormState({sent: true, error: true});
        } finally {
            // Reset the hCaptcha when the request has failed or succeeeded
            // so that it can be executed again if user submits another email.
            // setEmail("");
        }
    };

    return (
        <div className="bg-gray-50 py-16 px-4 overflow-hidden sm:px-6 lg:px-8 lg:py-24">
            <div className="relative max-w-xl mx-auto">
                <svg
                    className="absolute left-full transform translate-x-1/2"
                    width={404}
                    height={404}
                    fill="none"
                    viewBox="0 0 404 404"
                    aria-hidden="true"
                >
                    <defs>
                        <pattern
                            id="85737c0e-0916-41d7-917f-596dc7edfa27"
                            x={0}
                            y={0}
                            width={20}
                            height={20}
                            patternUnits="userSpaceOnUse"
                        >
                            <rect x={0} y={0} width={4} height={4} className="text-gray-200" fill="currentColor"/>
                        </pattern>
                    </defs>
                    <rect width={404} height={404} fill="url(#85737c0e-0916-41d7-917f-596dc7edfa27)"/>
                </svg>
                <svg
                    className="absolute right-full bottom-0 transform -translate-x-1/2"
                    width={404}
                    height={404}
                    fill="none"
                    viewBox="0 0 404 404"
                    aria-hidden="true"
                >
                    <defs>
                        <pattern
                            id="85737c0e-0916-41d7-917f-596dc7edfa27"
                            x={0}
                            y={0}
                            width={20}
                            height={20}
                            patternUnits="userSpaceOnUse"
                        >
                            <rect x={0} y={0} width={4} height={4} className="text-gray-200" fill="currentColor"/>
                        </pattern>
                    </defs>
                    <rect width={404} height={404} fill="url(#85737c0e-0916-41d7-917f-596dc7edfa27)"/>
                </svg>
                <div id="formBox"
                     className={classNames(
                         formState.sent ? 'hidden' : '',
                         "")}
                    >
                    <div className="text-center">
                        <h2 className="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">How can we
                            help?</h2>
                        <p className="mt-4 text-lg leading-6 text-gray-500">
                            Tell us about your blockchain goals and objectives as well as how you think 358 could help.
                        </p>
                    </div>
                    <div className="mt-12">
                        <form onSubmit={handleSubmit(onSubmit)}
                              className="grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-8">
                            <div>
                                <label htmlFor="given_name" className="block text-sm font-medium text-gray-700">
                                    Given name
                                </label>
                                <div className="mt-1 rounded-md shadow-sm">
                                    <input
                                        type="text"
                                        id="given_name"
                                        autoComplete="given-name"
                                        className={classNames(
                                            errors.given_name ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500' : 'focus:ring-cyan-400 focus:border-cyan-400',
                                            "py-3 px-4 block w-full shadow-sm border-gray-300 rounded-md")}
                                        // placeholder="Given Name"
                                        aria-invalid={errors.given_name ? "true" : "false"}
                                        aria-describedby="given-name-error"
                                        {...register("given_name", {required: true, minLength: 2, maxLength: 20})}
                                    />
                                    {errors.given_name &&
                                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                        <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true"/>
                                    </div>
                                    }
                                </div>
                                {errors.given_name &&
                                <p className="mt-2 text-sm text-red-600" id="given-name-error">
                                    Try a real given name
                                </p>
                                }
                            </div>
                            <div>
                                <label htmlFor="family_name" className="block text-sm font-medium text-gray-700">
                                    Family name
                                </label>
                                <div className="mt-1 rounded-md shadow-sm">
                                    <input
                                        type="text"
                                        id="family_name"
                                        autoComplete="family-name"
                                        className={classNames(
                                            errors.family_name ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500' : 'focus:ring-cyan-400 focus:border-cyan-400',
                                            "py-3 px-4 block w-full shadow-sm border-gray-300 rounded-md")}
                                        // placeholder="Given Name"
                                        aria-invalid={errors.family_name ? "true" : "false"}
                                        aria-describedby="family-name-error"
                                        {...register("family_name", {required: true, minLength: 2, maxLength: 20})}
                                    />
                                    {errors.family_name &&
                                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                        <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true"/>
                                    </div>
                                    }
                                </div>
                                {errors.family_name &&
                                <p className="mt-2 text-sm text-red-600" id="family-name-error">
                                    Try a real family name
                                </p>
                                }
                            </div>
                            {/*<div className="sm:col-span-2">*/}
                            {/*    <label htmlFor="company" className="block text-sm font-medium text-gray-700">*/}
                            {/*        Company*/}
                            {/*    </label>*/}
                            {/*    <div className="mt-1">*/}
                            {/*        <input*/}
                            {/*            type="text"*/}
                            {/*            name="company"*/}
                            {/*            id="company"*/}
                            {/*            autoComplete="organization"*/}
                            {/*            className="py-3 px-4 block w-full shadow-sm focus:ring-cyan-400 focus:border-cyan-400 border-gray-300 rounded-md"*/}
                            {/*        />*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            <div className="sm:col-span-2">
                                <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                    Email
                                </label>
                                <div className="mt-1 rounded-md shadow-sm">
                                    <input
                                        id="email"
                                        type="email"
                                        autoComplete="email"
                                        className={classNames(
                                            errors.email ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500' : 'focus:ring-cyan-400 focus:border-cyan-400',
                                            "py-3 px-4 block w-full shadow-sm border-gray-300 rounded-md")}
                                        // placeholder="Given Name"
                                        aria-invalid={errors.email ? "true" : "false"}
                                        aria-describedby="email-error"
                                        {...register("email", {
                                            required: true,
                                            pattern: /(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)])/
                                        })}
                                    />
                                    {errors.email &&
                                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                        <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true"/>
                                    </div>
                                    }
                                </div>
                                {errors.email &&
                                <p className="mt-2 text-sm text-red-600" id="email-error">
                                    Try a real email
                                </p>
                                }
                            </div>
                            <div className="sm:col-span-2 hidden">
                                <label htmlFor="phone" className="block text-sm font-medium text-gray-700">
                                    Email
                                </label>
                                <div className="mt-1 rounded-md shadow-sm">
                                    <input
                                        id="phone"
                                        type="phone"
                                        autoComplete="phone"
                                        className={classNames(
                                            errors.phone ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500' : 'focus:ring-cyan-400 focus:border-cyan-400',
                                            "py-3 px-4 block w-full shadow-sm border-gray-300 rounded-md")}
                                        // placeholder="Given Name"
                                        aria-invalid={errors.phone ? "true" : "false"}
                                        aria-describedby="phone-error"
                                        {...register("phone", {
                                            required: false
                                        })}
                                    />
                                </div>
                            </div>
                            {/*<div className="sm:col-span-2">*/}
                            {/*    <label htmlFor="phone_number" className="block text-sm font-medium text-gray-700">*/}
                            {/*        Phone Number*/}
                            {/*    </label>*/}
                            {/*    <div className="mt-1 relative rounded-md shadow-sm">*/}
                            {/*        <div className="absolute inset-y-0 left-0 flex items-center">*/}
                            {/*            <label htmlFor="country" className="sr-only">*/}
                            {/*                Country*/}
                            {/*            </label>*/}
                            {/*            <select*/}
                            {/*                id="country"*/}
                            {/*                name="country"*/}
                            {/*                className="h-full py-0 pl-4 pr-8 border-transparent bg-transparent text-gray-500 focus:ring-cyan-400 focus:border-cyan-400 rounded-md"*/}
                            {/*            >*/}
                            {/*                <option>US</option>*/}
                            {/*                <option>CA</option>*/}
                            {/*                <option>EU</option>*/}
                            {/*            </select>*/}
                            {/*        </div>*/}
                            {/*        <input*/}
                            {/*            type="text"*/}
                            {/*            name="phone_number"*/}
                            {/*            id="phone_number"*/}
                            {/*            autoComplete="tel"*/}
                            {/*            className="py-3 px-4 block w-full pl-20 focus:ring-cyan-400 focus:border-cyan-400 border-gray-300 rounded-md"*/}
                            {/*            placeholder="+1 (555) 987-6543"*/}
                            {/*        />*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            <div className="sm:col-span-2">
                                <label htmlFor="message" className="block text-sm font-medium text-gray-700">
                                    Message
                                </label>
                                <div className="mt-1 rounded-md shadow-sm">
                                <textarea
                                    id="message"
                                    rows={4}
                                    className={classNames(
                                        errors.message ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500' : 'focus:ring-cyan-400 focus:border-cyan-400',
                                        "py-3 px-4 block w-full shadow-sm border-gray-300 rounded-md")}
                                    aria-invalid={errors.message ? "true" : "false"}
                                    aria-describedby="message-error"
                                    {...register("message", {required: true, minLength: 20, maxLength: 2000})}
                                />
                                </div>
                                {errors.message &&
                                <p className="mt-2 text-sm text-red-600" id="email-error">
                                    Need an actual message
                                </p>
                                }
                            </div>
                            <div className="sm:col-span-2">
                                <div className="flex items-start">
                                    <div className="flex-shrink-0">
                                        <Switch
                                            checked={agreed}
                                            onChange={setAgreed}
                                            className={classNames(
                                                agreed ? 'bg-cyan-500' : 'bg-gray-200',
                                                'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-400'
                                            )}
                                        >
                                            <span className="sr-only">Agree to policies</span>
                                            <span
                                                aria-hidden="true"
                                                className={classNames(
                                                    agreed ? 'translate-x-5' : 'translate-x-0',
                                                    'inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
                                                )}
                                            />
                                        </Switch>
                                    </div>
                                    <div className="ml-3">
                                        <p className="text-base text-gray-500">
                                            <span>
                                            By selecting this, you agree to the{' '}
                                            <Link href="/privacy"><a className="font-medium text-gray-700 underline">
                                                Privacy Policy
                                            </a>
                                            </Link>
                                                , {' '}
                                            <Link href="/cookies"><a className="font-medium text-gray-700 underline">
                                                Cookie Policy
                                            </a>
                                            </Link>
                                                {' '}and{' '}
                                            <Link href="/tac"><a className="font-medium text-gray-700 underline">
                                                Terms and Conditions
                                            </a>
                                            </Link>

                                            {/*and{' '}*/}
                                            {/*<a href="#" className="font-medium text-gray-700 underline">*/}
                                            {/*    Cookie Policy*/}
                                            {/*</a>*/}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="sm:col-span-2">
                                <button
                                    type="submit"
                                    className={classNames(
                                        (agreed && !errors.given_name && !errors.family_name && !errors.email && !errors.message) ? 'bg-cyan-500 hover:bg-cyan-700' : 'bg-gray-500',
                                        "w-full inline-flex items-center justify-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-400")}
                                    disabled={!agreed || (errors.given_name || errors.family_name || errors.email || errors.message)}
                                >
                                    Let's talk
                                </button>
                            </div>
                            <HCaptcha
                                id="test"
                                size="invisible"
                                ref={hcaptchaRef}
                                sitekey={process.env.NEXT_PUBLIC_HCAPTCHA_KEY as string}
                                onVerify={onHCaptchaChange}
                            />
                        </form>
                    </div>
                </div> {/*end formBox*/}
                <div id="formSuccess"
                     className={classNames(
                         formState.sent && !formState.error ? '' : 'hidden',
                         "")}
                >
                    <div className="rounded-md bg-green-50 p-4">
                        <div className="flex">
                            <div className="flex-shrink-0">
                                <CheckCircleIcon className="h-5 w-5 text-green-400" aria-hidden="true" />
                            </div>
                            <div className="ml-3">
                                <h3 className="text-2xl font-medium font-bold text-green-800">Message sent!</h3>
                                <div className="mt-2 text-lg text-green-700">
                                    <p>We'll be in touch shortly.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="formError"
                     className={classNames(
                         formState.sent && formState.error ? '' : 'hidden',
                         "")}
                >
                    <div className="rounded-md bg-red-50 p-4">
                        <div className="flex">
                            <div className="flex-shrink-0">
                                <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
                            </div>
                            <div className="ml-3">
                                <h3 className="text-2xl font-medium font-bold text-red-800">Could not submit form</h3>
                                <div className="mt-2 text-lg text-red-700">
                                    <p>Please try again later.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
